import { render } from "./Clone.vue?vue&type=template&id=6c06a5ba&scoped=true"
import script from "./Clone.vue?vue&type=script&lang=js"
export * from "./Clone.vue?vue&type=script&lang=js"

import "./Clone.vue?vue&type=style&index=0&id=6c06a5ba&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c06a5ba"]])

export default __exports__